<main class="app-content" [class.app-content--loading]="loadingService.isLoading$ | async">
	<router-outlet />
</main>

@if (loadingService.isLoading$ | async) {
	<output class="loading-overlay" aria-live="polite" aria-label="Loading data">
		<div class="loading-spinner" aria-hidden="true"></div>
	</output>
}
